module.exports = __webpack_public_path__ + "img/789077f.png";